import { render, staticRenderFns } from "./CTAPlus.vue?vue&type=template&id=38e4554a&scoped=true"
import script from "./CTAPlus.vue?vue&type=script&lang=js"
export * from "./CTAPlus.vue?vue&type=script&lang=js"
import style0 from "./CTAPlus.vue?vue&type=style&index=0&id=38e4554a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4554a",
  null
  
)

export default component.exports